import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Leads from './components/Leads';
import Prospects from './components/Prospects';
import EmailQueue from './components/EmailQueue';
import Settings from './components/Settings';
import MessageLog from './components/MessageLog';
import SetterExport from './components/SetterExport';
import Scripts from './components/Scripts';
import { api } from './utils/api';

export default function App() {
  const [page, setPage] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Seed existing clients once on startup
  useEffect(() => {
    api.seedExistingClients().catch(() => {});
  }, []);

  const pages = {
    dashboard: <Dashboard />,
    leads: <Leads />,
    prospects: <Prospects />,
    email: <EmailQueue />,
    messagelog: <MessageLog />,
    setterexport: <SetterExport />,
    scripts: <Scripts />,
    settings: <Settings />,
  };

  return (
    <div className="flex h-screen bg-gray-950">
      <Sidebar
        page={page}
        setPage={(p) => { setPage(p); setSidebarOpen(false); }}
        open={sidebarOpen}
        setOpen={setSidebarOpen}
      />
      <div className="flex-1 overflow-auto">
        <div className="md:hidden p-4">
          <button onClick={() => setSidebarOpen(true)} className="text-gray-400 hover:text-white">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        <main className="p-4 md:p-8 max-w-7xl mx-auto">
          {pages[page]}
        </main>
      </div>
    </div>
  );
}
